import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createBlock as _createBlock, Teleport as _Teleport, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = {
  hidden: "",
  "data-test-ref": "app"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_mhtk_module_injector = _resolveComponent("mhtk-module-injector")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.loading)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.teleportComponentList, (teleportComponent) => {
          return (_openBlock(), _createBlock(_Teleport, {
            key: teleportComponent.teleportTo,
            to: teleportComponent.teleportTo
          }, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(teleportComponent.component), _normalizeProps(_guardReactiveProps(teleportComponent.props)), null, 16 /* FULL_PROPS */))
          ], 8 /* PROPS */, ["to"]))
        }), 128 /* KEYED_FRAGMENT */))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" Initialize Modules "),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.moduleInitializers, (initializer) => {
      return (_openBlock(), _createBlock(_component_mhtk_module_injector, {
        key: initializer.moduleName,
        "initialize-module": initializer.initializeModule,
        "initialize-module-options": initializer.initializeModuleOptions,
        onInitializeSuccess: ($event: any) => (_ctx.onInitializeModuleSuccess(initializer)),
        onInitializeError: ($event: any) => (_ctx.onInitializeModuleError(initializer, $event))
      }, null, 8 /* PROPS */, ["initialize-module", "initialize-module-options", "onInitializeSuccess", "onInitializeError"]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}